import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Header } from "@/layouts/Header";
import { Sidebar } from "@/layouts/Sidebar";
import { useProductPageTracking } from "@/hooks/useProductPageTracking";
import { ChatbotWidget } from "@/components/ChatbotWidget";

export function AppShell() {
  useProductPageTracking();
  const location = useLocation();
  const hideChatbot = location.pathname.startsWith("/business-intelligence/chat");

  return (
    <div className="flex h-full min-h-0 bg-zinc-50 dark:bg-zinc-950">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header />
        <main className="min-h-0 flex-1 overflow-y-auto p-5 md:p-6">
          <Outlet />
        </main>
      </div>
      {!hideChatbot ? <ChatbotWidget /> : null}
    </div>
  );
}
